import React from "react";
import './Spinner.css';

function Spinner(){
    return(
       <div>
            <div className="spinner"> </div>
            <p>Loading....</p>
       </div>
    );
}

export default Spinner;